import { render, staticRenderFns } from "./mirror.vue?vue&type=template&id=d1b59884&scoped=true"
import script from "./mirror.vue?vue&type=script&lang=js"
export * from "./mirror.vue?vue&type=script&lang=js"
import style0 from "./mirror.vue?vue&type=style&index=0&id=d1b59884&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b59884",
  null
  
)

export default component.exports